import { useState } from 'react';
import { Document as RichtextDocument } from '@contentful/rich-text-types';

import { RichTextConverter } from '@/services/richtextConverter/richtextConverter';
import { Container, Cross } from './Banner.style';

interface BannerProps {
  bannerContent: RichtextDocument;
}

export default function Banner({ bannerContent }: BannerProps) {
  const [bannerVisible, setBannerVisible] = useState(() => {
    const stored = localStorage.getItem('bannerDismissed');
    return !stored;
  });

  const closeBanner = () => {
    setBannerVisible(false);
    localStorage.setItem('bannerDismissed', 'true');
  };

  if (!bannerVisible) return null;

  return (
    <Container>
      {RichTextConverter(bannerContent)}
      <Cross onClick={closeBanner} />
    </Container>
  );
}
